import styled from "styled-components";

import { media } from "@src/common/styles/mixins";
import DefaultModalWrapper from "@src/modules/shared/components/Modal/DefaultModalWrapper";

export const DicomHeadersModalWrapper = styled(DefaultModalWrapper)`
  ${media.up("MOBILE")`
    max-width: 80vw;
  `}
`;
